import type {AppState} from 'core/types';
import {app} from 'core/util';

import {NAME} from './constants';

const getModel = app.createGetModel(NAME);

export const isFetching = (state: AppState, entity: string, defaultValue = false): boolean => getModel(state)[entity] ?? defaultValue;
